module.exports = __webpack_public_path__ + "static/media/twitter-login.5b1cf058.svg";